import { render, staticRenderFns } from "./OOProfessionalServiceDetails.vue?vue&type=template&id=73d2dfc2&scoped=true&"
import script from "./OOProfessionalServiceDetails.vue?vue&type=script&lang=ts&"
export * from "./OOProfessionalServiceDetails.vue?vue&type=script&lang=ts&"
import style0 from "./OOProfessionalServiceDetails.vue?vue&type=style&index=0&id=73d2dfc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d2dfc2",
  null
  
)

export default component.exports